import * as yup from 'yup';

export const combineFieldValidations = (fields) => {
  const validations = fields.reduce((acc, field) => {
    return { ...acc, [field.name]: field.validation };
  }, {});
  return yup.object(validations);
};
